<template>
  <div class="flex scroll-area" :key="lesson">
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      class="absolute top-[15%] z-[60] bg-blues p-2 lg:hidden cursor-pointer h-[40px] rounded-r-xl"
      @click="toggleMenu"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="20"
        height="20"
        viewBox="0 0 50 50"
        fill="#fff"
      >
        <path
          d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"
        ></path>
      </svg>
    </div>

    <div
      class="lg:flex fixed w-[85%] bg-white lg:w-[35%] xl:w-[30%] 2xl:w-[25%] lg:relative z-[60] m-4 px-5 py-4 rounded-3xl"
      :class="{ hidden: !isMobile }"
      style="box-shadow: 0px 2px 30px 0px #01b0f926"
    >
    <div
      @click="toggleSidebar"
      class="absolute top-2 right-[2px] z-30 block lg:hidden bg-gray-200 rounded-full p-1 cursor-pointer"
    >
      <!-- <span class="text-2xl">⬅️</span> -->
      <img src="@/assets/leftaaa.svg" alt="" srcset="" class="w-5 h-5" />
    </div>
      <div>
        <div
          class="hidden lg:flex flex-col gap-5 relative w-full overflow-y-auto heighttab border-r border-gray-200 pr-4"
        >
          <router-link
            :to="{ name: 'StudentCourseProgress' }"
            class="flex items-center gap-5 p-4 rounded-3xl"
            :class="{ 'bg-[#0085DB]': $route.name == 'StudentCourseProgress' }"
          >
            <img
              src="@/assets/newd/icons/Grid.png"
              v-if="$route.name == 'StudentCourseProgress'"
              alt=""
            />
            <img
              src="@/assets/newd/icons/Grid-1.png"
              v-if="$route.name != 'StudentCourseProgress'"
              alt=""
            />
          </router-link>

          <router-link
            :to="{ name: 'StudentMessages' }"
            class="flex items-center gap-5 p-4 rounded-3xl"
            :class="{ 'bg-[#0085DB]': $route.name == 'StudentMessages' }"
          >
            <img
              src="@/assets/newd/icons/mdi-light_forum-1.png"
              v-if="$route.name == 'StudentMessages'"
              alt=""
            />
            <img
              src="@/assets/newd/icons/mdi-light_forum.png"
              v-if="$route.name != 'StudentMessages'"
              alt=""
            />
          </router-link>

          <router-link
            :to="{ name: 'StudentAssignments' }"
            class="flex items-center gap-5 p-4 rounded-3xl"
            :class="{ 'bg-[#0085DB]': $route.name == 'StudentAssignments' }"
          >
            <img
              src="@/assets/newd/icons/gg_notes-1.png"
              v-if="$route.name == 'StudentAssignments'"
              alt=""
            />
            <img
              src="@/assets/newd/icons/gg_notes.png"
              v-if="$route.name != 'StudentAssignments'"
              alt=""
            />
          </router-link>

          <router-link
            :to="{ name: 'StudentNewForums' }"
            class="flex items-center gap-5 p-4 rounded-3xl"
            :class="{ 'bg-[#0085DB]': $route.name == 'StudentNewForums' }"
          >
            <img
              src="@/assets/newd/icons/Archive-1.png"
              v-if="$route.name == 'StudentNewForums'"
              alt=""
            />
            <img
              src="@/assets/newd/icons/Archive.png"
              v-if="$route.name != 'StudentNewForums'"
              alt=""
            />
          </router-link>

          <router-link
            :to="{ name: 'StudentClasses' }"
            class="flex items-center gap-5 p-4 rounded-3xl"
            :class="{ 'bg-[#0085DB]': $route.name == 'StudentClasses' }"
          >
            <img
              src="@/assets/newd/icons/Calendar2Week-1.png"
              v-if="$route.name == 'StudentClasses'"
              alt=""
            />
            <img
              src="@/assets/newd/icons/Calendar2Week.png"
              v-if="$route.name != 'StudentClasses'"
              alt=""
            />
          </router-link>

          <router-link
            :to="{ name: 'StudentAssessments' }"
            class="flex items-center gap-5 p-4 rounded-3xl"
            :class="{ 'bg-[#0085DB]': $route.name == 'StudentAssessments' }"
          >
            <img
              src="@/assets/newd/icons/BarChartLine-1.png"
              v-if="$route.name == 'StudentAssessments'"
              alt=""
            />
            <img
              src="@/assets/newd/icons/BarChartLine.png"
              v-if="$route.name != 'StudentAssessments'"
              alt=""
            />
          </router-link>

          <router-link
            :to="{ name: 'StudentReport' }"
            class="flex items-center gap-5 p-4 rounded-3xl"
            :class="{ 'bg-[#0085DB]': $route.name == 'StudentReport' }"
          >
            <img
              src="@/assets/newd/icons/CloudArrowDown-1.png"
              v-if="$route.name == 'StudentReport'"
              alt=""
            />
            <img
              src="@/assets/newd/icons/CloudArrowDown.png"
              v-if="$route.name != 'StudentReport'"
              alt=""
            />
          </router-link>

          <router-link
            :to="{ name: 'StudentProject' }"
            class="flex items-center gap-5 p-4 rounded-3xl"
            :class="{ 'bg-[#0085DB]': $route.name == 'StudentProject' }"
          >
            <img
              src="@/assets/newd/icons/gg_notes-1.png"
              v-if="$route.name == 'StudentProject'"
              alt=""
            />
            <img
              src="@/assets/newd/icons/gg_notes.png"
              v-if="$route.name != 'StudentProject'"
              alt=""
            />
          </router-link>
        </div>
      </div>

      <!-- Side Nav Menu -->
      <div
        class="flex flex-col relative w-full h-full overflow-y-auto heighttab"
        id="scroll-container"
        @scroll="saveScroll"
        ref="navMenu"
      >
        <div v-for="section in sectionInfo.data" :key="section.id">
          <div
            class="text-black flex items-center rounded-2xl px-3 py-1 justify-between cursor-pointer"
            @click="courseSectionToggle(section.id)"
          >
            <p class="font-bold text-sm py-3 text-black">
              {{ section.title }}
            </p>
            <img
              src="@/assets/new/up.png"
              v-if="activeCourseMenu == section.id"
              style="height: 6px !important"
              alt=""
            />
            <img
              src="@/assets/new/down.png"
              v-if="activeCourseMenu != section.id"
              style="height: 6px !important"
              alt=""
            />
          </div>

          <div
            v-if="activeCourseMenu == section.id"
            v-for="(lesson, index) in lessonInfo.results"
            :key="lesson.id"
          >
            <div
              class="my-1 flex flex-col"
              v-if="section.id == lesson.section_id"
            >
              <router-link
                :to="{ name: 'LessonView', params: { lesson_id: lesson.id } }"
                v-if="lesson.section_participant.status == true"
                class="flex items-center rounded-2xl px-3 py-2 cursor-pointer"
                :data-lesson-id="lesson.id"
                :ref="`lesson-${lesson.id}`"
              >
                <div class="w-[16px]">
                  <div class="w-[18px]">
                    <img
                      src="@/assets/mdi_tick-circle-outline.png"
                      class="object-cover w-4 h-4 font-semibold"
                    />
                  </div>
                </div>
                <p
                  class="text-sm py-1 pl-1"
                  :class="{
                    'text-blues font-bold actived': lesson_id == lesson.id,
                  }"
                >
                  {{ lesson.title }}
                </p>
              </router-link>

              <router-link
                :to="{ name: 'LessonView', params: { lesson_id: lesson.id } }"
                v-else
                class="flex items-center rounded-2xl px-3 py-2 cursor-pointer"
                :data-lesson-id="lesson.id"
                :ref="`lesson-${lesson.id}`"
              >
                <div class="w-[18px]">
                  <div class="w-[16px]">
                    <p v-if="lesson.file_type == 'video'">🎥</p>
                    <p v-if="lesson.file_type == 'download'">⬇️</p>
                    <p v-if="lesson.file_type == 'document'">📄</p>
                    <p v-if="lesson.file_type == 'pdf'">📕</p>
                    <p v-if="lesson.file_type == 'word'">📘</p>
                    <p v-if="lesson.file_type == 'general'">⚫</p>
                  </div>
                </div>
                <p
                  class="text-sm py-1 pl-1"
                  :class="{
                    'text-blues font-bold actived': this.lesson_id == lesson.id,
                  }"
                >
                  {{ lesson.title }}
                </p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content Area -->
    <div
      class="w-[95%] lg:mr-4 mt-4 rounded-3xl h-[calc(100vh-100px)]"
      style="box-shadow: 0px 2px 30px 0px #01b0f926"
    >
      <!-- Desktop Navigation -->
      <div class="hidden lg:block top-0">
        <div class="flex items-center pt-10 px-10 justify-between">
          <router-link
            :to="{ name: 'StudentCourseProgress' }"
            class="bg-blues text-xs text-white px-6 py-1.5 rounded-2xl"
          >
            Back
          </router-link>
          <h1
            class="text-lg 2xl:text-lg font-semibold w-[50%] mx-auto text-center 2xl:w-[60%] line-clamp-3"
          >
            {{ $route.params.title }}
          </h1>

          <div class="flex items-center gap-10 text-sm">
            <div
              @click="goToPreviousLesson"
              class="flex items-center gap-4 cursor-pointer"
              v-if="lesson.previous_id != null"
            >
              <img src="@/assets/new/left.png" class="h-3" />
              <p class="text-base">Previous</p>
            </div>

            <div
              @click="goToNextLesson"
              class="flex items-center gap-4 cursor-pointer"
              v-if="lesson.next_id != null"
            >
              <p class="text-base">Next</p>
              <img src="@/assets/new/right.png" class="h-3" />
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Navigation -->
      <div
        class="flex flex-col gap-4 items-center pt-10 px-5 justify-between block lg:hidden"
      >
        <div class="flex flex-col gap-2 justify-between w-full">
          <div class="flex justify-end">
            <router-link
              :to="{ name: 'StudentCourseProgress' }"
              class="bg-blues text-xs text-white px-6 py-1.5 rounded-2xl"
            >
              Back
            </router-link>
          </div>
        </div>

        <div class="flex items-center gap-10 text-sm">
          <router-link
            :to="{
              name: 'LessonView',
              params: { lesson_id: lesson.previous_id },
            }"
            class="flex items-center gap-4 cursor-pointer"
            v-if="lesson.previous_id != null"
          >
            <img src="@/assets/new/left.png" class="h-3" />
            <p class="text-base">Previous</p>
          </router-link>
          <router-link
            :to="{ name: 'LessonView', params: { lesson_id: lesson.next_id } }"
            class="flex items-center gap-4 cursor-pointer"
            v-if="lesson.next_id != null"
          >
            <p class="text-base">Next</p>
            <img src="@/assets/new/right.png" class="h-3" />
          </router-link>
        </div>
      </div>

      <!-- Lesson Content -->
      <div class="p-5 lg:p-10 flex flex-col gap-10 -mt-5" v-if="lesson">
        <div class="flex flex-col gap-4 top-[10%]">
          <div class="flex items-center justify-between w-full">
            <h1 class="text-lg lg:text-lg font-semibold">
              {{ lesson.title }}
            </h1>

            <div class="flex items-center justify-end gap-10" :key="lesson">
              <div v-if="lessonCompletedData == null">
                <button
                  class="bg-blues text-xs text-white block px-6 py-1.5 rounded-2xl"
                  @click="completeUnit(lesson.section_id, lesson.id)"
                >
                  Complete
                </button>
              </div>

              <div v-else>
                <button
                  class="bg-green-700 text-white text-xs px-4 py-2 rounded-2xl"
                >
                  Lesson Completed
                </button>
              </div>
            </div>
          </div>

          <div class="flex items-center gap-10 -mt-3">
            <div class="flex items-center rounded-2xl py-3 gap-2">
              <img src="@/assets/new/time.png" alt="" class="h-4 w-4" />
              <p class="text-xs">{{ lesson.duration }} min</p>
            </div>
          </div>
        </div>

        <!-- Video/Content Area -->
        <div class="overflow-y-auto -mt-10 h-[85vh] lg:h-[80vh] px-2">
          <div
            v-if="lesson.video_url != null && lesson.video_url != ''"
            class="bg-gray-200 rounded-lg lg:pt-5 relative"
          >
            <iframe
              v-if="matchYoutubeUrl(lesson.video_url)"
              class="w-full lg:h-[280px] mx-auto rounded p-3"
              :src="lesson.video_url"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            >
            </iframe>

            <video
              v-else
              ref="videoPlayer"
              :src="lesson.video_url"
              class="w-full lg:h-[280px] mx-auto rounded p-3"
              controls
              @ended="addPolls(lesson)"
              @loadedmetadata="onMetadataLoaded"
              autoplay
            ></video>

            <!-- Poll Display -->
            <div
              v-if="lesson.show_polls"
              class="flex flex-col gap-3 px-10 pb-5"
            >
              <p class="text-xs font-bold">Poll answers:</p>
              <div
                class="flex items-center gap-3"
                v-if="lesson.poll_details != null"
              >
                <p
                  v-for="option in lesson.poll_details.options"
                  :key="option"
                  class="bg-blues px-3 py-1 rounded-xl text-xs text-gray-300"
                >
                  <span class="font-bold text-white"
                    >({{ option.count }} users)</span
                  >
                  {{ option.text }}
                </p>
              </div>
            </div>

            <!-- Poll Modal -->
            <div
              v-if="isPoll"
              class="absolute w-full h-full top-0 right-0 bottom-0 left-0 flex items-center justify-center bg-black bg-opacity-50"
            >
              <div
                v-if="poll_status"
                class="bg-white w-[50%] rounded-xl px-6 py-5 flex flex-col justify-center items-center gap-4 relative"
              >
                <p
                  class="bg-red-500 rounded-full text-xs w-5 h-5 flex items-center justify-center text-white absolute -right-2 -top-2 cursor-pointer"
                  @click="isPoll = false"
                >
                  x
                </p>
                <h1 class="text-center text-black text-xl font-semibold">
                  Thankyou !
                </h1>
                <p
                  :class="[
                    this.messages.type == 'success'
                      ? 'text-green-400'
                      : 'text-red-400',
                  ]"
                  class="capitalize text-md text-center"
                >
                  {{ this.messages.text }}
                </p>
              </div>
              <form
                v-else
                @submit.prevent="pollSubmit"
                class="bg-white w-[50%] rounded-xl px-6 py-5 flex flex-col gap-4 relative"
              >
                <p
                  class="bg-red-500 rounded-full text-xs w-5 h-5 flex items-center justify-center text-white absolute -right-2 -top-2 cursor-pointer"
                  @click="isPoll = false"
                >
                  x
                </p>
                <div class="flex flex-col gap-3">
                  <div class="text-black font-semibold">
                    {{ this.poll_question.question }}
                  </div>
                  <div
                    v-for="poll in this.poll_question.options"
                    :key="poll.id"
                    class="flex flex-col gap-3"
                  >
                    <div class="flex gap-2 items-center">
                      <input
                        type="radio"
                        :value="poll.id"
                        v-model="selected_poll_option"
                        :id="'poll_' + poll.id"
                        name="pollOption"
                        class="cursor-pointer p-1"
                      />
                      <label :for="'poll_' + poll.id">{{ poll.text }}</label>
                    </div>
                  </div>
                </div>

                <div
                  class="flex flex-col gap-2"
                  v-if="selected_poll_option != null"
                >
                  <label for="remark">Remark</label>
                  <input
                    type="text"
                    v-model="remarks"
                    name="remarks"
                    class="cursor-pointer p-1 border rounded-lg"
                  />
                </div>
                <div>
                  <button
                    type="submit"
                    class="bg-blues text-white px-3 py-1 rounded-lg text-xs"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>

            <!-- Autoplay Countdown Popup -->
            <div
              v-if="showPopup"
              class="z-[1000] flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
            >
              <div
                class="!z-999 relative flex justify-center items-center bg-white p-5 lg:p-8 w-[90%] lg:w-[380px] rounded-lg"
              >
                <div class="w-full flex flex-col gap-3">
                  <p class="mb-2 text-sm">
                    Next video will autoplay in {{ countdown }} seconds.
                  </p>
                  <div class="w-full flex items-center justify-center">
                    <button
                      @click="cancelAutoplay"
                      class="bg-blues text-white px-4 py-2 rounded-lg"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Additional Content -->
          <div class="flex flex-col gap-4">
            <div v-html="lesson.content" class="w-full video-container"></div>

            <iframe
              v-if="lesson.pdf_file != null && lesson.pdf_file != ''"
              :src="convertHttpToHttps(lesson.pdf_file)"
              class="lg:h-[400px]"
            ></iframe>

            <p class="text-sm" v-if="lesson.keyworeds">
              <span class="font-semibold">Keywords:</span>
              {{ lesson.keyworeds }}
            </p>

            <audio
              controls
              v-if="lesson.audio_file != null && lesson.audio_file != ''"
            >
              <source :src="lesson.audio_file" type="audio/ogg" />
              <source :src="lesson.audio_file" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>

            <!-- Quiz Section -->
            <div v-if="lesson.lesson_or_quiz == 'quiz'">
              <div v-if="lesson.quizzes">
                <div v-if="lesson.quizzes != null">
                  <div v-if="lesson.quizzes[0]">
                    <div
                      v-if="lesson.quizzes[0].quiz.id"
                      class="flex flex-col gap-5"
                    >
                      <div class="flex flex-col gap-2">
                        <p
                          class="text-base font-bold"
                          v-if="lesson.quizzes[0].quiz.question_attempt"
                        >
                          Quiz Attempt Count: {{ lesson.user_quize_count }} /
                          {{ lesson.quizzes[0].quiz.question_attempt_count }}
                        </p>
                      </div>

                      <div v-if="lesson.quizzes[0].quiz.question_attempt">
                        <div
                          v-if="
                            lesson.user_quize_count ==
                            lesson.quizzes[0].quiz.question_attempt_count
                          "
                          class="flex flex-col items-center justify-center gap-4 py-6 px-10 border rounded-xl"
                        >
                          <p class="text-lg font-semibold text-center">
                            You have completed all attempt of the Quiz.
                          </p>
                          <router-link
                            :to="{
                              name: 'StudentAssessments',
                              query: {
                                tab: 'lesson',
                                quiz_id: lesson.quizzes[0].quiz.id,
                              },
                            }"
                            class="flex items-center gap-5 px-4 py-2 rounded-xl bg-[#0085DB]"
                          >
                            <p class="font-bold text-xs text-white">
                              View Score Board
                            </p>
                          </router-link>
                        </div>
                        <div
                          v-else-if="lessonCompletedData != null"
                          class="flex flex-col items-center justify-center gap-4 py-6 px-10 border rounded-xl"
                        >
                          <p class="text-lg font-semibold text-center">
                            Lesson completed can't attend Quiz.
                          </p>
                          <router-link
                            :to="{
                              name: 'StudentAssessments',
                              query: {
                                tab: 'lesson',
                                quiz_id: lesson.quizzes[0].quiz.id,
                              },
                            }"
                            class="flex items-center gap-5 px-4 py-2 rounded-xl bg-[#0085DB]"
                          >
                            <p class="font-bold text-xs text-white">
                              View Score Board
                            </p>
                          </router-link>
                        </div>
                        <div v-else>
                          <QuizTest
                            v-if="lesson.quizzes[0].quiz.id"
                            :key="quizKey"
                            :course_id="this.course_id"
                            :quiz_id="lesson.quizzes[0].quiz.id"
                            :taker_id="lesson.course_quiz_takers_id"
                            @pushLessonComplete="receiveLessonComplete"
                          />
                        </div>
                      </div>
                      <div v-else>
                        <div
                          v-if="lesson.course_quiz_takers_id != null"
                          class="flex flex-col items-center justify-center gap-4 py-6 px-10 border rounded-xl"
                        >
                          <p class="text-lg font-semibold text-center">
                            You have completed the Quiz.
                          </p>
                          <router-link
                            :to="{
                              name: 'StudentAssessments',
                              query: {
                                tab: 'lesson',
                                quiz_id: lesson.quizzes[0].quiz.id,
                              },
                            }"
                            class="flex items-center gap-5 px-4 py-2 rounded-xl bg-[#0085DB]"
                          >
                            <p class="font-bold text-xs text-white">
                              View Score Board
                            </p>
                          </router-link>
                        </div>
                        <div v-else-if="lesson.course_quiz_takers_id == null">
                          <div
                            v-if="lessonCompletedData != null"
                            class="flex flex-col items-center justify-center gap-4 py-6 px-10 border rounded-xl"
                          >
                            <p class="text-lg font-semibold text-center">
                              Lesson completed can't attend Quiz.
                            </p>
                            <router-link
                              :to="{
                                name: 'StudentAssessments',
                                query: {
                                  tab: 'lesson',
                                  quiz_id: lesson.quizzes[0].quiz.id,
                                },
                              }"
                              class="flex items-center gap-5 px-4 py-2 rounded-xl bg-[#0085DB]"
                            >
                              <p class="font-bold text-xs text-white">
                                View Score Board
                              </p>
                            </router-link>
                          </div>
                          <div v-else>
                            <QuizTest
                              v-if="lesson.quizzes[0].quiz.id"
                              :key="quizKey"
                              :course_id="this.course_id"
                              :quiz_id="lesson.quizzes[0].quiz.id"
                              :taker_id="lesson.course_quiz_takers_id"
                              @pushLessonComplete="receiveLessonComplete"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState, mapMutations } from "vuex";
import QuizTest from "@/views/Student/Dashboard/QuizTestComp.vue";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  name: "Lesson",

  props: ["lesson_id", "course_id"],

  components: {
    QuizTest,
    FlashMessage,
  },

  data() {
    return {
      lesson: "",
      lessonCompletedData: null,
      sectionInfo: "",
      lessonInfo: "",
      activeCourseMenu: null,
      showbutton: false,
      messages: {
        text: "",
        type: "null",
      },
      showPopup: false,
      countdown: 10,
      countdownInterval: null,
      isPoll: false,
      poll_question: null,
      selected_poll_question: null,
      selected_poll_option: null,
      player: null,
      poll_status: false,
      remarks: "",
      isMobile: false,
      hide_menu: true,
      scrollQueue: [],
      isScrolling: false,
      navigationTimeout: null,
      quizKey: 0,
    };
  },

  watch: {
    immediate: true,
    async "$route.params.lesson_id"(newId, oldId) {
      if (newId !== oldId) {
        this.quizKey++;

        if (this.lessonInfo.results) {
          const targetLesson = this.lessonInfo.results.find(
            (l) => l.id === parseInt(newId)
          );
          if (targetLesson && targetLesson.section_id) {
            this.activeCourseMenu = targetLesson.section_id;
          }
        }

        await this.getLesson();
        await this.getCompletedLesson();
        await this.detailsgets();

        this.$nextTick(() => {
          this.scrollToActiveLessonById(newId);
        });
      }
    },
  },

  computed: {
    ...mapGetters(["userInfo"]),
    ...mapState(["navScrollPosition"]),
  },

  created() {
    this.getLesson();
    this.getCompletedLesson();
    this.detailsgets();
  },

  mounted() {
    this.$nextTick(() => {
      if (this.lesson_id && this.lessonInfo.results) {
        this.scrollToActiveLessonById(this.lesson_id);
      }
    });

    const video = this.$refs.videoPlayer;
    if (video) {
      video.play().catch((err) => {
        console.error("Autoplay failed:", err);
      });
    }

    if (this.lesson.section_participant) {
      if (this.lesson.section_participant.status == null) {
        this.completeUnitStart();
      }
    }
  },

  beforeUnmount() {
    if (this.navigationTimeout) {
      clearTimeout(this.navigationTimeout);
    }
    this.scrollQueue = [];
  },

  methods: {
    ...mapMutations(["setNavScrollPosition"]),

    saveScroll() {
      if (this.$refs.navMenu) {
        this.setNavScrollPosition(this.$refs.navMenu.scrollTop);
      }
    },

    navigateToLesson(lessonId) {
      this.saveScroll();

      this.$router.push({
        name: "LessonView",
        params: { lesson_id: lessonId },
      });
    },

    courseSectionToggle(sectionId) {
      this.activeCourseMenu =
        this.activeCourseMenu === sectionId ? null : sectionId;
    },

    goToNextLesson() {
      if (this.lesson.next_id) {
        if (this.lessonInfo.results) {
          const nextLesson = this.lessonInfo.results.find(
            (l) => l.id === parseInt(this.lesson.next_id)
          );
          if (nextLesson && nextLesson.section_id) {
            this.activeCourseMenu = nextLesson.section_id;
          }
        }
        this.navigateToLesson(this.lesson.next_id);
      }
    },

    goToPreviousLesson() {
      if (this.lesson.previous_id) {
        if (this.lessonInfo.results) {
          const prevLesson = this.lessonInfo.results.find(
            (l) => l.id === parseInt(this.lesson.previous_id)
          );
          if (prevLesson && prevLesson.section_id) {
            this.activeCourseMenu = prevLesson.section_id;
          }
        }
        this.navigateToLesson(this.lesson.previous_id);
      }
    },

    restoreScrollPosition() {
      this.$nextTick(() => {
        if (this.lesson_id) {
          this.scrollToActiveLessonById(this.lesson_id);
        }
      });
    },

    ensureSectionExpandedAndScroll(lessonId) {
      if (
        !this.lessonInfo ||
        !this.lessonInfo.results ||
        this.lessonInfo.results.length === 0
      ) {
        return;
      }

      const targetLesson = this.lessonInfo.results.find(
        (l) => l.id === parseInt(lessonId)
      );

      if (!targetLesson || !targetLesson.section_id) {
        return;
      }

      if (this.activeCourseMenu !== targetLesson.section_id) {
        this.activeCourseMenu = targetLesson.section_id;
        this.$nextTick(() => {
          this.scrollToActiveLessonById(lessonId);
        });
      } else {
        this.scrollToActiveLessonById(lessonId);
      }
    },

    scrollToActiveLessonById(lessonId) {
      requestAnimationFrame(() => {
        const activeElement = document.querySelector(
          `[data-lesson-id="${lessonId}"]`
        );
        const navMenu = this.$refs.navMenu;

        if (activeElement && navMenu) {
          const elementTop = activeElement.offsetTop;
          const elementHeight = activeElement.offsetHeight;
          const containerHeight = navMenu.clientHeight;

          const desiredScrollTop =
            elementTop - containerHeight / 2 + elementHeight / 2;

          navMenu.scrollTo({
            top: Math.max(0, desiredScrollTop),
            behavior: "smooth",
          });

          requestAnimationFrame(() => {
            this.saveScroll();
          });
        }
      });
    },

    toggleSidebar() {
      this.isMobile = false;
      this.hide_menu = true;
    },

    toggleMenu() {
      this.isMobile = !this.isMobile;
      this.hide_menu = !this.isMobile;
    },

    pollSubmit() {
      const poll_data = {
        poll: this.selected_poll_question,
        option: this.selected_poll_option,
        student: this.userInfo.user.id,
        remarks: this.remarks,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/poll/answer/?Key=${this.userInfo.token_key}`,
          poll_data
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.getLesson();
            this.messages = {
              text: resp.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
              this.isPoll = false;
              this.startCountdown();
            }, 2000);
          } else if (resp.data.status == 400) {
            this.messages = {
              text: "Poll Already Submitted",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
              this.isPoll = false;
            }, 2000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    matchYoutubeUrl(url) {
      var p =
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      if (url.match(p)) {
        return true;
      }
      return false;
    },

    addPollsinTime() {
      const currentTime = this.$refs.videoPlayer.currentTime;
      console.log("check", currentTime);
    },

    addPolls(poll) {
      if (poll.polls) {
        if (!this.lesson.user_poll) {
          this.isPoll = true;
          this.poll_question = poll.poll_details;
          this.selected_poll_question = poll.poll_details.id;
        } else {
          this.startCountdown();
        }
      } else {
        this.startCountdown();
      }
    },

    onMetadataLoaded() {
      // loadedmetadata
      // get video meta data's like duration, etc...
      // const duration = this.$refs.videoPlayer.duration;
      // console.log("check", duration/60);
      // const fiveMinutes = 5 * 60;
      //   if (duration > fiveMinutes) {
      //       triggerTime = duration - fiveMinutes;
      //   }
    },

    async detailsgets() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/section/?course_name=${this.course_id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          this.sectionInfo = response.data;
        });

      await axios
        .get(
          `${process.env.VUE_APP_API}/lessons/?Key=${this.userInfo.token_key}&course_name=${this.course_id}`
        )
        .then((response) => {
          this.lessonInfo = response.data;
          return response.data;
        });
    },

    getLesson() {
      return axios
        .get(
          `${process.env.VUE_APP_API}/lessons/?Key=${this.userInfo.token_key}&id=${this.lesson_id}`
        )
        .then((response) => {
          if (response) {
            this.lesson = response.data.results[0];
            this.activeCourseMenu = response.data.results[0].section_id;
            return response.data.results[0];
          } else {
            console.log("got error");
          }
        });
    },

    convertHttpToHttps(url) {
      if (url.startsWith("http://")) {
        return url.replace("http://", "https://");
      }
      return url;
    },

    async getCompletedLesson() {
      this.lessonCompletedData = null;
      await axios
        .get(
          `${process.env.VUE_APP_API}/completed-lesson-tracking/${this.userInfo.user.id}/${this.lesson_id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.lessonCompletedData = "";
          } else {
            console.log("Something went wrong::");
          }
        });
    },

    receiveLessonComplete() {
      // this.completeUnit();
    },

    async quizPreview(id) {
      let token = this.userInfo.token_key;
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${id}/?Key=${token}`
        )
        .then((response) => {
          this.dataval = response.data.data;
        });
    },

    async completeUnitStart() {
      await axios
        .post(
          `${process.env.VUE_APP_API}/lesson-tracking-create/${this.userInfo.user.id}/${this.lesson.section_id}/${this.lesson_id}/?Key=${this.userInfo.token_key}`,
          {}
        )
        .then((response) => {
          if (response) {
            this.getCompletedLesson();
            this.detailsgets();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async completeUnit() {
      await axios
        .post(
          `${process.env.VUE_APP_API}/lesson-tracking/${this.userInfo.user.id}/${this.lesson.section_id}/${this.lesson_id}/?Key=${this.userInfo.token_key}`,
          {}
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
              window.location.reload();
            }, 3000);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onVideoEnded() {
      this.startCountdown();
    },

    startCountdown() {
      this.showPopup = true;
      this.countdown = 10;

      this.countdownInterval = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
        } else {
          this.loadNextVideo();
        }
      }, 1000);
    },

    cancelAutoplay() {
      clearInterval(this.countdownInterval);
      this.showPopup = false;
    },

    loadNextVideo() {
      clearInterval(this.countdownInterval);
      this.showPopup = false;

      const nextId = this.lesson.next_id;
      if (nextId) {
        this.$router.push({
          name: "LessonView",
          params: { lesson_id: nextId },
        });
      } else {
        alert("No more videos.");
      }
    },
  },
};
</script>

<style scoped>
td,
thead,
tr,
th {
  text-align: center;
  padding: 10px 20px;
  border: 1px solid black !important;
}

.heighttab {
  height: calc(110vh - 250px) !important;
}

#scroll-container {
  scroll-behavior: smooth;
}

.heightfix {
  height: calc(110vh - 250px) !important;
}

.heightfixed {
  height: calc(100vh - 450px) !important;
}

:deep(.video-container iframe) {
  width: 100% !important;
  height: auto !important;
  aspect-ratio: 16 / 9;
  max-height: 500px;
}

::-webkit-scrollbar {
  display: none;
}
</style>
